import { useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { Storage } from '@capacitor/storage';
import { useIonViewDidEnter } from '@ionic/react';
import Form from '../components/contact/Form';
import Subscribe from '../components/contact/Subscribe';
import Socials from '../components/contact/Socials';
import Map from '../components/Map';

const Contact = () => {
    const [config, setConfig] = useState({}) as any;
    useIonViewDidEnter(() => {
        const getConfig = async () => {
            const { value } = await Storage.get({ key: 'config' });
            if (value) {
                const objectValue = JSON.parse(value);
                setConfig(objectValue);
            } else {
                setConfig({});
            }
        }
        getConfig();
    })
    return (
        <IonPage className="page-padding-top">
            <IonContent fullscreen>
                <div className="ion-padding">
                    <Socials />
                    <Subscribe />
                    <Map location={[config.contact_map_lat !== undefined && config.contact_map_lat, config.contact_map_long !== undefined && config.contact_map_long]} />
                    <Form />
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Contact;
